import script from "./AddUserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddUserMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AddUserMenu.vue?vue&type=style&index=0&id=d69d09b2&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69d09b2"]])

export default __exports__